import { Injectable } from '@angular/core';
import * as JSZip from 'jszip';

export interface BannerProperties {
  html?: string;
  fallbackImg?: string;
  width?: number;
  height?: number;
  lang?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AssetBannerHtmlService {
  async checkZipForHtml(file: File): Promise<BannerProperties> {
    return new Promise((resolve, reject) => {
      const zip = new JSZip();
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const blob = new Blob([e.target.result], { type: file.type });
        const res = await zip.loadAsync(blob);
        const keys = Object.keys(res.files);
        const contains: BannerProperties = {};

        contains.html = keys.find((key: string) => key.includes('.htm'));
        if (!contains.html) {
          // likely not a html banner
          resolve(contains);
        }

        let fallbackImg = keys.find((key: string) => key.includes('fallback') || key.includes('Fallback'));
        if (!fallbackImg) {
          fallbackImg = keys.find((key: string) => key.includes('backup') || key.includes('Backup'));
        }
        contains.fallbackImg = fallbackImg;

        //reading the index.html file and parsing height, width and lang from meta tag
        if (contains.html) {
          res.files[contains.html].async('text').then(
            (markup) => {
              if (markup.toLowerCase().trim().indexOf('<!doctype') === 0) {
                const regex = new RegExp(/<html\s\s?lang\s?=[^>]*>/gm);
                const htmlTag = regex.exec(markup);
                if (htmlTag && htmlTag.length > 0) {
                  const temp = htmlTag[0].split('lang="');
                  contains.lang = temp[temp.length - 1].split('"')[0];
                } else {
                  contains.lang = 'en';
                }
                const doc = document.implementation.createHTMLDocument('');
                doc.documentElement.innerHTML = markup;

                const metaTags = doc.getElementsByTagName('meta');
                this.extractSize(metaTags, contains);
              }
              resolve(contains);
            },
            (err) => {
              reject(err);
            },
          );
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }

  private extractSize(metaTags: HTMLCollectionOf<HTMLElement>, contains: BannerProperties) {
    for (let i = 0; i < metaTags.length; i++) {
      const metaTag = metaTags.item(i);
      const content = metaTag?.getAttribute('content');
      if (content && content.indexOf('height=') !== -1 && content.indexOf('width=') !== -1) {
        const contentValues = content.split(',');
        contentValues.forEach((val) => {
          const keyVal = val.split('=');
          (contains as any)[keyVal[0]] = parseInt(keyVal[1], 10);
        });
        return;
      }
    }
  }
}
